import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch } from 'vue'
import { InputLoja } from '@/../common/types/Loja'
import { obrigatorio } from '@/shareds/regras'
import { criarLoja, storageLogoLojaRef } from '@/shareds/sharedsLoja'
import LojaService from '@/services/LojaService'
import SeletorDePotencia from '@/components/SeletorDePotencia.vue'
import { authModule, alert } from '@/store'
import { storage } from '@/firebase'
import { v4 as uuidv4 } from 'uuid'
import { intersectRoles } from '../../helpers/auth-helpers'
import { onBeforeRouteLeave, useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormLoja',
  props: {
	novo: { type: Boolean, default: false },
	id: { type: String },
},
  setup(__props) {

const props = __props;



const router = useRouter()

const versaoAnterior = ref<string | null>(null)
const carregando = ref(true)
const erro = ref<string | null>(null)
const loja = ref<InputLoja>(criarLoja())

const salvando = ref(false)

const form = ref<HTMLFormElement & {
	validate: (() => boolean),
}>()
const logoInput = ref<HTMLInputElement>()

const novaLogo = ref<File | null>(null)
const logoPreview = ref('')

const logoLoja = computed(() => logoPreview.value || loja.value.urlLogo)

function removerLogo() {
	loja.value.urlLogo = ''
	novaLogo.value = null
}

function onLogoChange() {
	const input = logoInput.value!
	if (!input.files) return
	const [file] = input.files
	novaLogo.value = file
}

watch(novaLogo, (logo) => {
	if (!logo) {
		logoPreview.value = ''
		return
	}
	const reader = new FileReader()

	reader.addEventListener('load', () => {
		logoPreview.value = reader.result as string
	}, false)

	reader.readAsDataURL(logo)
}, { immediate: true })

async function carregarLoja() {
	carregando.value = true
	erro.value = null
	try {
		loja.value = props.novo
			? criarLoja()
			: await (LojaService
				.get(props.id!)
				.then((loja) => ({
					...loja,
					potencia: loja.potencia._id,
					somar: (loja.somar && typeof loja.somar === 'object') ? loja.somar?._id : loja.somar,
				})))
		nextTick().then(() => {
			versaoAnterior.value = JSON.stringify(loja.value)
		})
	} catch (error) {
		erro.value = (error as any).message
	} finally {
		nextTick(() => {
			carregando.value = false
		})
	}
}

carregarLoja()

async function salvar() {
	if (!form.value!.validate()) { return }
	salvando.value = true
	try {
		if (novaLogo.value) {
			const ref = storage.ref(`${storageLogoLojaRef}/${uuidv4()}`)
			const snapshot = await ref.put(novaLogo.value, {
				customMetadata: {
					fileName: novaLogo.value.name,
				},
			})
			const donwloadUrl = await snapshot.ref.getDownloadURL()
			loja.value.urlLogo = donwloadUrl || ''
		}
		props.novo
			? await LojaService.post(loja.value)
			: await LojaService.put(props.id!, loja.value)
		versaoAnterior.value = JSON.stringify(loja.value)
		router.go(-1)
	} catch (error) {
		alert.setError(error)
	} finally {
		salvando.value = false
	}
}

function validarSaida(): false | void {
	if(versaoAnterior.value === JSON.stringify(loja.value)) return
	return confirm("Alguns dados não foram salvos. Deseja mesmo sair?") && undefined
}

onBeforeRouteLeave((to, from, next) => {
	next(validarSaida())
})

return { __sfc: true,props, router, versaoAnterior, carregando, erro, loja, salvando, form, logoInput, novaLogo, logoPreview, logoLoja, removerLogo, onLogoChange, carregarLoja, salvar, validarSaida, obrigatorio, SeletorDePotencia, authModule, intersectRoles }
}

})